module.exports = __webpack_public_path__ + "438d6f391bf5fde340acbc06519d1450.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/crown-2-s.png
// module id = 2786
// module chunks = 0